// extracted by mini-css-extract-plugin
export default {"calendarEventNormal":"NormalCalendarEvent_calendarEventNormal__HVAJk","iconText":"NormalCalendarEvent_iconText__xMM1A"};